import { formatStatusLabel } from "@/lib/format";

const POINTS_LEDGER_BADGE_TONES = {
  slate:
    "border-slate-300 bg-slate-100 text-slate-800 dark:border-slate-700/60 dark:bg-slate-900/40 dark:text-slate-200",
  zinc: "border-zinc-300 bg-zinc-100 text-zinc-900 dark:border-zinc-700/60 dark:bg-zinc-900/40 dark:text-zinc-200",
  red: "border-red-300 bg-red-100 text-red-900 dark:border-red-800/60 dark:bg-red-950/40 dark:text-red-200",
  amber:
    "border-amber-300 bg-amber-100 text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-200",
  emerald:
    "border-emerald-300 bg-emerald-100 text-emerald-900 dark:border-emerald-800/60 dark:bg-emerald-950/40 dark:text-emerald-200",
  sky: "border-sky-300 bg-sky-100 text-sky-900 dark:border-sky-800/60 dark:bg-sky-950/40 dark:text-sky-200",
  blue: "border-blue-300 bg-blue-100 text-blue-900 dark:border-blue-800/60 dark:bg-blue-950/40 dark:text-blue-200",
  violet:
    "border-violet-300 bg-violet-100 text-violet-900 dark:border-violet-800/60 dark:bg-violet-950/40 dark:text-violet-200",
} as const;

type PointsLedgerTone = keyof typeof POINTS_LEDGER_BADGE_TONES;

function normalizePointsLedgerType(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase().replace(/\s+/g, "_");
}

const TYPE_LABELS: Record<string, string> = {
  earned: "Earned",
  redeemed: "Redeemed",
  forfeiture: "Forfeiture",
  refund: "Refund",
  cancellation_credit: "Cancellation Credit",
  admin_credit: "Admin Credit",
  admin_debit: "Admin Debit",
  migration: "Account Migration",
};

const TYPE_TONES: Record<string, PointsLedgerTone> = {
  earned: "emerald",
  refund: "emerald",
  cancellation_credit: "emerald",
  admin_credit: "sky",
  redeemed: "blue",
  admin_debit: "red",
  forfeiture: "amber",
  migration: "violet",
};

export function formatPointsLedgerTypeLabel(type: unknown): string {
  const normalized = normalizePointsLedgerType(type);
  return TYPE_LABELS[normalized] ?? formatStatusLabel(normalized, "Unknown");
}

export function getPointsLedgerTypeBadgeClass(type: unknown): string {
  const normalized = normalizePointsLedgerType(type);
  const tone = TYPE_TONES[normalized] ?? "slate";
  return POINTS_LEDGER_BADGE_TONES[tone];
}

